import { ErrorObject, logError } from '@/Hooks/useGlobalErrorHandler';
import { v1 } from 'uuid';
import { ZodSchema } from 'zod';

export const parseSchema = async (schema: ZodSchema, data: unknown) => {
    const parsed = schema.safeParse(data);
    if (!parsed.success) {
        const errors = parsed.error.errors.map((err) => err.message).join(', ');
        const errObject: ErrorObject = {
            errorKey: `zodParser-${v1()}`,
            message: JSON.stringify(parsed.error),
        }
        logError(errObject);
        throw new Error(errors);
    }
    return parsed.data;
};